import { useEffect, useRef, useState } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/i18n/LanguageProvider";

export function LanguageSwitcher({ testIdPrefix = "language" }) {
  const { language, languages, setLanguage, meta } = useLanguage();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div className="lang-switcher" ref={wrapRef}>
      <button
        type="button"
        className="lang-trigger"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={t("language.label")}
        data-testid={`${testIdPrefix}-switcher-trigger`}
      >
        <Globe size={15} />
        <span className="lang-trigger-code">{language.toUpperCase()}</span>
        <span className="lang-trigger-label">{meta.label}</span>
        <ChevronDown size={13} />
      </button>
      {open && (
        <ul className="lang-menu" role="listbox" data-testid={`${testIdPrefix}-switcher-menu`}>
          {languages.map(l => (
            <li key={l.code}>
              <button
                type="button"
                role="option"
                aria-selected={l.code === language}
                className={`lang-option${l.code === language ? " active" : ""}`}
                onClick={() => { setLanguage(l.code); setOpen(false); }}
                data-testid={`${testIdPrefix}-switcher-option-${l.code}`}
              >
                <span className="lang-option-code">{l.code.toUpperCase()}</span>
                <span className="lang-option-label">{l.label}</span>
                {l.code === language && <Check size={14} className="lang-option-check" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
